import React from "react";
import { useTranslation } from "react-i18next";
import BaseButton from "@/components/base/button/BaseButton.tsx";
import { Portal } from "react-portal";
import { cn } from "@/lib/utils.ts";
import IconX from "/src/assets/icons/x-mark.svg?react";

interface WeeklyModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const WeeklyModal: React.FC<WeeklyModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  return (
    <Portal>
      <div
        className={cn("fixed inset-0 bg-dark/80 flex justify-center items-center z-50", !isOpen && "hidden")}
      >
        <div
          className="bg-[linear-gradient(150deg,_#45454D_0%,_#14141E_72.24%)] p-4 rounded-20 text-center grid items-center justify-center max-w-[310px] w-full shadow-lg relative before:rounded-20 before:absolute before:inset-0 before:border-2 before:border-white/08 before:pointer-events-none"
        >
          <img className="w-[200px] h-[200px] absolute -top-24 left-0 right-0 mx-auto" src="don.webp" alt="No internet." />
          <div
            onClick={onClose}
            className="absolute top-4 right-4 bg-white/08 rounded-full p-2 cursor-pointer" // Added cursor-pointer
          >
            <IconX />
          </div>
          <h2 className="text-2xl mt-12 font-extrabold text-white leading-130 my-2">
            {t("weekly_tasks")}
          </h2>
          <p className="text-sm text-white/70 leading-130 mb-8">
            {t("weekly-tasks-desc")}
          </p>
          <BaseButton
            text={t("task_completion")}
            onClick={onClose}
          />
        </div>
      </div>
    </Portal>
  );
};

export default WeeklyModal;